import {BoardNewCardContainer, BoardNewCardTitle} from "./BoardNewCard.styled";
import {UiAddButton} from "../addButton";

interface BoardNewCardProps {
  uploadFile: () => void
}

export function BoardNewCard({uploadFile}: BoardNewCardProps) {
  return (
    <BoardNewCardContainer onClick={uploadFile}>
      <BoardNewCardTitle>Upload New</BoardNewCardTitle>
      <UiAddButton aboutFunction={uploadFile} />
    </BoardNewCardContainer>
  )
}